import React from 'react';
import Skeleton from 'wsm-skeleton';

export const FooterSkeletonContainerClasses = ['p-0', 'mt-8'];

// US2092262 — see DetailsSkeleton.jsx: the same skeleton-only 48px top margin,
// for the same reason. The two together are the 96px an off-view card shrinks by.
export const FooterSkeletonHeightParityClasses = ['p-0'];

const FooterSkeleton = () => (
	<Skeleton height="50px" dataTestId="footer-skeleton" />
);

export default FooterSkeleton;
